import { StatusChip } from '@/components/ui/StatusChip';
import type { Agent } from '@/hooks/useAgents';
import { getAgentStatusProps } from '@/sections/agents/utils/agentStatus';
import { cn } from '@/utils/classname';

/**
 * Agent status badge component
 *
 * Displays simplified agent status with icon and color coding:
 * - Online (blue): Connected within configured threshold (5 minutes)
 * - Offline (red): Not seen within configured threshold
 *
 * Detailed health information is available in the Health tab.
 */

interface AgentStatusBadgeProps {
  agent: Agent;
  className?: string;
}

export function AgentStatusBadge(props: AgentStatusBadgeProps) {
  const { agent, className } = props;

  const agentStatusProps = getAgentStatusProps(agent);

  if (!agentStatusProps) return null;

  return <StatusChip {...agentStatusProps} className={cn(className)} />;
}
